import React from 'react';
import {
  intervalModes,
  intervalModeIds,
} from '../../../../../shared/configs/selectionData/intervalModes';
import IntervalStatusIcon from '../IntervalStatusIcon';
import styles from './index.module.scss';

const IntervalStatusBadges = () => {
  return (
    <div className={styles.root}>
      <Block title="Занятые интервалы" isBusy />
      <Block title="Свободные интервалы" />
    </div>
  );
};

export default IntervalStatusBadges;

const ids = Object.values(intervalModeIds);

function Block({ title, isBusy = false }) {
  const items = isBusy
    ? ids.filter((id) => id !== intervalModeIds.universal)
    : ids;

  return (
    <div>
      <span className={styles.blockTitle}>{title}</span>
      <ul className={styles.list}>
        {items.map((id) => (
          <li key={id}>
            <IntervalStatusIcon withExpertId={id} isBusy={isBusy} bordered />
            {intervalModes.get(id)}
          </li>
        ))}
      </ul>
    </div>
  );
}
